<template>
  <div
    v-if="items.length > 0"
    class="more-filters text-center cursor-pointer ml-2"
  >
    <div
      @click="isVisible = !isVisible"
      :class="` ${isVisible ? `active` : ``}`"
      v-if="items.length > 0"
    >
      ...
    </div>
    <div v-show="isVisible" class="hidden-filters-container position-absolute">
      <div
        class="filtered-item"
        v-for="(filter, index) of items.map(item => ({
          ...item,
          hidden: true
        }))"
        :key="index"
      >
        {{ filter.category }} : {{ filter.label }}
        <img
          class="cursor-pointer"
          :src="closeFilterIconPath"
          alt="close filtered item"
          @click="remove(filter)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomHomeHiddenFilters",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    closeFilterIconPath: {
      type: String,
      default: ""
    }
  },
  mounted() {
    document.addEventListener("click", this.clickOutside);
  },
  computed: {
    isVisible: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  methods: {
    remove(item) {
      this.$emit("remove", item);
    },
    clickOutside(event) {
      if (!(this.$el == event.target || this.$el.contains(event.target))) {
        this.isVisible = false;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.filtered-item {
  border-radius: 5px;
  background: rgba(205, 210, 229, 0.5);
  display: inline-flex;
  padding: 6px 9px;
  align-items: center;
  gap: 16px;
  height: auto;
  justify-content: space-between;
}

.hidden-filters-container {
  width: 300px;
  max-height: 345px;
  flex-shrink: 0;
  border-radius: 7px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.14);
  top: 30px;
  z-index: 10000;
  right: 0;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: auto;
}

.more-filters {
  position: relative;
  width: 45px;
  height: 17px;
  flex-shrink: 0;
  border-radius: 3.5px;
  background: rgba(207, 212, 231, 0.5);
  box-shadow: 0px 0px 73px 0px rgba(0, 0, 0, 0.14);
  margin-top: auto;
  margin-bottom: 8px;
}

.active {
  border-radius: 3.5px;
  background: #363abb;
  box-shadow: 0px 0px 73px 0px rgba(0, 0, 0, 0.14);
  color: #ffffff;

  :not(:has(.filtered-item)) {
    color: #707070;
    display: flex;
    justify-content: space-between;
  }
}

.hidden-filters-container::-webkit-scrollbar {
  width: 2px; /* Set the width of the scrollbar */
}

.hidden-filters-container::-webkit-scrollbar-thumb {
  background-color: #363abb; /* Set the color of the scrollbar thumb */
  border-radius: 6px; /* Round the edges of the thumb */
  border: 2px solid #363abb;
}

.hidden-filters-container::-webkit-scrollbar-thumb:hover {
  background-color: #363abb; /* Change thumb color on hover */
}
</style>
